import React from 'react';
import PhotoDropzone from '../upload/PhotoDropzone';

export default function Step5Photos() {
  return (
    <div className="p-6 max-w-xl">
      <h2 className="text-lg font-bold text-gray-900 mb-1">Photos</h2>
      <p className="text-sm text-gray-500 mb-6">
        Great photos increase Etsy sales. Add a cover image buyers will see first, then step-by-step photos to guide makers.
      </p>

      <div className="space-y-8">
        <PhotoDropzone
          category="cover"
          label="Cover Photo"
          hint="This appears on the PDF cover page and as your Etsy listing thumbnail. Use a clean, well-lit photo of the finished piece."
          maxPhotos={5}
        />

        <div className="border-t border-stone-100" />

        <PhotoDropzone
          category="step"
          label="Step-by-Step Photos"
          hint="Optional: photos that walk makers through tricky steps. These appear inside the pattern PDF."
          maxPhotos={20}
        />

        <div className="border-t border-stone-100" />

        <PhotoDropzone
          category="assembly"
          label="Assembly Photos"
          hint="Optional: photos showing how to assemble the pieces together."
          maxPhotos={10}
        />
      </div>
    </div>
  );
}
